/**
 * ? @description : Audio Modal Component
 */

// Dependencies
import React, { useEffect, useState } from "react";
import { Modal, Button, Form, FloatingLabel } from "react-bootstrap";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import ReactAudioPlayer from "react-audio-player";

// Assets
// import music from "../../../../../assets/Rain-dolby-sound.mp3";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";

// Table Component
import AudioHistoryTable from "./audio_history/AudioHistoryTable";
import { LoadingButton } from "@mui/lab";
import axios from "axios";

function AudioModal(props) {

  // * Redux
  const dispatch = useDispatch();

  // * Logged Username
  const username = sessionStorage.getItem("username");
  const userId = sessionStorage.getItem("user_id");

  // * State Variables
  const [audioDetails, setAudioDetails] = useState([]);
  const [audioHistory, setAudioHistory] = useState([]);
  const [audioComments, setAudioComments] = useState({
    audio_status: "approved",
    audio_reason: "",
    audio_audit_by: username,
    audio_audit_by_id:userId,
  });
  const [loading, setLoading] = useState(false);

  // TODO : Selected Teacher Id
  const selected_teacher_id = props.tabledata[0];
  const audioData = props.tabledata;

  // ? API Call : Post Method : To Get Audio Source Details
  useEffect(() => {
    const controller = axios.CancelToken.source();
    async function getAudioDetails() {
      try {
        if (props.tabledata.length > 0) {
          // let audio_status = ""
            // props.tabledata[12].props.children.props.children.props.title ===
            // "Audio Approved"
            //   ? "approved"
            //   : props.tabledata[12].props.children.props.children.props
            //       .title === "Audio Rejected"
            //   ? "rejected"
            //   : props.tabledata[12].props.children.props.children.props
            //       .title === "Audio Resend"
            //   ? "resend"
            //   : props.tabledata[12].props.children.props.children.props
            //       .title === "Audio Submitted"
            //   ? "submitted"
            //   : "unsubmitted";

            // const teacherId = props.tabledata[0];
          
          

          const requestObject = {
            teacher_id: selected_teacher_id,
            audio_status: audioData[9].props.children.props["aria-label"]
          };
  
          const options = {
            method: "POST",
            url: `audio/update/admin/getresource`,
            auth: true,
            data: requestObject,
            token:{cancelToken: controller.token}
          };

          const response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            options.token,
          );

          if (response.status === 200) {
            setAudioDetails(response.data);
          }
          // console.log(response.data);
        }
      } catch (error) {
        if(!axios.isCancel(error)){
          dispatch(
            showSnackbar({
              message: "Failed to fetch audio resource file.",
              severity: "error",
            })
          );
        }
      }
    }

    getAudioDetails();
    return () => {
      controller.cancel();
  }
  }, [selected_teacher_id, dispatch, audioData, props.tabledata.length]);

  // TODO : Promise Call
  function helpGetAudioHistory(options) {
    const promise = new Promise((resolve, reject) => {
      if (options)
        resolve(Axios(options.method, options.url, options.auth, options.data, options.controller));
      else reject("Error occurred");
    });

    return promise;
  }


  // ? API Call : Get Method : To Get Audio History
  useEffect(() => {
    // TODO : Function Call
    const controller = axios.CancelToken.source();
    (async () => {
      try {
        if (props.tabledata.length > 0) {
          const options = {
            method: "GET",
            url: `/audio/update/admin/audiohistory/${selected_teacher_id}`,
            auth: true,
            data: null,
            token:{cancelToken: controller.token}
          };

          const response = await helpGetAudioHistory(options);

          if (response.status === 200) {
            setAudioHistory(response.data.reverse());
          }
        }
      } catch (error) {
        if(!axios.isCancel(error)) { 
          dispatch(
            showSnackbar({
              message: "Failed to fetch audio history.",
              severity: "error",
            })
          );}
      }
    })()
    return () => {
      controller.cancel();
  }
  }, [selected_teacher_id, dispatch, props.tabledata.length]);

  // ? API Call : Put Method : Send Audio Comments to DB Server
  async function postAudioComments() {
    try {
      setLoading(true);
      const selected_audio_id = audioDetails[audioDetails.length - 1].audio_id;

      const options = {
        method: "put",
        url: `/audio/update/admin/${selected_audio_id}`,
        auth: true,
        data: audioComments,
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      if (response.status === 201) {
        
        setAudioComments(prev => ({...prev, audio_reason: ""}));
        setLoading(false);
        props.onHide();
        // window.location.reload();
        props.onCloseCallback();
        dispatch(
          showSnackbar({
            message: "Audio information has been uploaded successfully, but notifications have not been sent!",
            severity: "success",
          })
        );
      } else if(response.status === 200){
        setAudioComments(prev => ({...prev, audio_reason: ""}));
        setLoading(false);
        props.onHide();
        // window.location.reload();
        props.onCloseCallback();
        dispatch(
          showSnackbar({
            message: "Audio information uploaded successfully!",
            severity: "success",
          })
        );
      }
    } catch (error) {
      setLoading(false);
      dispatch(
        showSnackbar({
          message: "Error occurred while posting comments.",
          severity: "error",
        })
      );
    }
  }
 
  return (
    audioDetails.length > 0 && (
      <Modal
        show={props.show}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton onClick={props.onHide}>
          <Modal.Title id="contained-modal-title-vcenter">
            <h3><strong>{props.tabledata[1].props["aria-label"]}</strong>'s audio details</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Title */}
          <h3>File name: <div>
          <strong> {audioDetails?.length > 0 &&
          audioDetails[audioDetails?.length - 1].audio_file_name?.slice(0, 65)}
        {audioDetails[audioDetails?.length - 1].audio_file_name?.length > 50
          ? "..."
          : ""}</strong>
            </div></h3>

          {/* Audio */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ReactAudioPlayer src={audioDetails[audioDetails.length - 1].audio_source} controls />
          </div>

          
          {/* Table */}
          <Box sx={{ mt: "16px", mb: "16px" }}>
            <h5>Audio history</h5>

            <AudioHistoryTable data={audioHistory} />
          </Box>

          {/* Form */}
          {audioData.length !== 0 && 
          (audioData[9].props.children.props["aria-label"] === "resend" ||
           audioData[9].props.children.props["aria-label"] === "submitted") && 
          (
            <div>
              <div>
                <label>Audio Status</label>
                <Form.Select
                  aria-label="status-select"
                  onChange={(e) =>
                    setAudioComments({
                      ...audioComments,
                      audio_status: e.target.value,
                    })
                  }
                >
                  <option >Select the Audio Status</option>
                  <option value="approved">Approved</option>
                  {/* <option value="rejected">Rejected</option> */}
                  <option value="resend">Resend</option>
                </Form.Select>
              </div>

              <br />

              <div>
                <FloatingLabel
                  controlId="floatingTextarea2"
                  label="Write a reason"
                >
                  <Form.Control
                    as="textarea"
                    placeholder="Write a reason here"
                    style={{ height: "100px" }}
                    value={audioComments.audio_reason}
                    onChange={(e) =>
                      setAudioComments({
                        ...audioComments,
                        audio_reason: e.target.value,
                      })
                    }
                  />
                </FloatingLabel>
              </div>

              {/* Button */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "16px",
                }}
              >
                <Button
                  type="button"
                  variant="light"
                  onClick={() => {
                    setAudioComments({
                      ...audioComments,
                      audio_status: "approved",
                      audio_reason: "",
                    });
                    props.onHide();
                  }}
                >
                  RESET
                </Button>
                <LoadingButton
                  sx={{mx: 3}}
                  type="submit"
                  variant="contained"
                  loading={loading}
                  onClick={() => {
                    if(audioComments.audio_reason !== ""){
                      postAudioComments();
                    }else{
                      dispatch(
                        showSnackbar({
                          message: "Please fill your reason before posting",
                          severity: "error",
                        })
                      );
                    }
                  }}
                >
                  POST
                </LoadingButton>
              </div>
            </div>
          )}

        </Modal.Body>

        {/* <Modal.Footer>
          <Button type="button" variant="light" onClick={props.onHide}>
            CANCEL
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={() => alert("This function not integrated !")}
          >
            SAVE
          </Button>
        </Modal.Footer> */}
      </Modal>
    )
  );
}

export default AudioModal;
